import { render } from "./BaseSpinner.vue?vue&type=template&id=2389dacc&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=2389dacc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2389dacc"

export default script